<template>
  <v-app id="systimes">
    <v-container>
      <v-row justify="center">
        <v-col md="6">
          <v-toolbar color="blue" dark>
            <v-app-bar-nav-icon to="/settings"></v-app-bar-nav-icon>
            <v-toolbar-title>
              SysTimes
              <span class="version">V.:&nbsp;{{ version }}</span>
            </v-toolbar-title>
          </v-toolbar>
        </v-col>
      </v-row>

      <v-row class="mt-6" justify="center">
        <v-col md="6">
          <router-view></router-view>
        </v-col>
      </v-row>
    </v-container>
    
    <!-- Diàleg d'errors de connexió -->
    <ConnectionErrorDialog />
  </v-app>
</template>

<script>
import axios from "./httpClient.js";
import api from "./api.js";
import ConnectionErrorDialog from "./components/ConnectionErrorDialog.vue";

export default {
  components: {
    ConnectionErrorDialog
  },
  data: () => ({
    version: localStorage.getItem("systimes.version"),
  }),
  methods: {
    async validateTokenOnAppStart() {
      const token = localStorage.getItem("systimes.token" + api.getEmp());
      const currentRoute = this.$route.path;
      
      // If no token is stored, go to token screen
      if (!token) {
        this.$store.commit("setAuth", false);
        this.$router.push("/Token");
        return;
      }
      
      try {
        const result = await api.validateToken(token);
        
        if (result.isValid) {
          // Token is valid - go to home if not already on a specific route
          this.$store.commit("setAuth", true);
          if (currentRoute === "/" || currentRoute === "/Token") {
            this.$router.push("/");
          }
          // If user is on another route, let them stay there
        } else if (result.isConnectionError) {
          // Connection error - handle differently based on current route
          console.log("Connection error during app startup");
          this.$store.commit("setAuth", false);
          
          if (currentRoute === "/Token") {
            // If already on token screen, stay there but don't show connection error
            // Token.vue will handle the connection error display
          } else {
            // If on any other route, stay there and let the component handle the connection error
            // Don't redirect to /Token for connection errors
            console.log("Staying on current route due to connection error");
          }
        } else {
          // Token is invalid - go to token screen
          this.$store.commit("setAuth", false);
          this.$router.push("/Token");
        }
      } catch (error) {
        console.error("Unexpected error validating token on app start:", error);
        // For unexpected errors, don't redirect to token screen
        this.$store.commit("setAuth", false);
      }
    }
  },
  mounted() {
    // Validate token using the improved validation logic
    this.validateTokenOnAppStart();
  },
  created() {
    console.log("Comprovant actualitzacions...");
    fetch(api.URL() + "/api/v1/version")
      .then((response) => {
        return response.json();
      })
      .then((version) => {
        console.log(version);
        if (localStorage.getItem("systimes.version") != version) {
          console.log("Actualitzo!");
          localStorage.setItem("systimes.version", version);
          setTimeout(
            function () {
              window.location.reload(true);
            },
            2000
          );
        }
      })
      .catch((error) => {
        console.error("Error comprovant versió:", error);
        // No mostrar error per la comprovació de versió, ja que no és crítica
      });
  }
};
</script>